import getAxiosInstance from '../js/axios/axios';

const otm = getAxiosInstance('otm');

export const postUserLog = params => {
  return otm.post('/log-user', params, {retry: true});
};
